/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { DocumentServiceFactoryProxy } from "../../documentServiceFactoryProxy.js";
import { DocumentServiceCompressionAdapter } from "./documentServiceCompressionAdapter.js";
import { DocumentStorageServiceCompressionAdapter as DocumentStorageServiceSummaryBlobCompressionAdapter } from "./summaryblob/index.js";
export class DocumentServiceFactoryCompressionAdapter extends DocumentServiceFactoryProxy {
    constructor(serviceFactory, _config) {
        super(serviceFactory);
        this._config = _config;
    }
    async createContainer(createNewSummary, createNewResolvedUrl, logger, clientIsSummarizer) {
        if (createNewSummary !== undefined) {
            const configForInitial = this._config;
            const newAppSumary = DocumentStorageServiceSummaryBlobCompressionAdapter.compressSummary(createNewSummary.tree[".app"], configForInitial);
            createNewSummary.tree[".app"] = newAppSumary;
        }
        const service = await this.serviceFactory.createContainer(createNewSummary, createNewResolvedUrl, logger, clientIsSummarizer);
        return new DocumentServiceCompressionAdapter(service, this._config);
    }
    async createDocumentService(resolvedUrl) {
        const service = await this.serviceFactory.createDocumentService(resolvedUrl);
        return new DocumentServiceCompressionAdapter(service, this._config);
    }
}
//# sourceMappingURL=documentServiceFactoryCompressionAdapter.js.map